import { ChartColumnIcon, CircleCheckIcon } from 'lucide-react';
import { DetailSection } from '../DetailSection/DetailSection';
import { DetailSectionItem } from '../DetailSectionItem/DetailSectionItem';
import { SectionTitle } from '../SectionTitle/SectionTitle';
import type { WhyItMattersSectionProps } from './WhyItMatters.types';
import { useTranslation } from 'react-i18next';

export function WhyItMattersSection({ item }: WhyItMattersSectionProps) {
  const { t } = useTranslation('contentTest');

  const getSourceLabel = (source: (typeof item.overview.trendOrigin.sources)[string]): string => {
    if (source.post) {
      return t('socialBriefWidget.whyItMattersSection.postLabel', {
        title:
          source.post.title ||
          source.post.published_by_name ||
          t('socialBriefWidget.whyItMattersSection.untitledPost'),
      });
    }
    if (source.document) {
      return t('socialBriefWidget.whyItMattersSection.docLabel', {
        fileName: source.document.fileName,
      });
    }
    if (source.url) {
      return source.url;
    }
    return t('socialBriefWidget.whyItMattersSection.otherSource');
  };

  const mapSourceKeysToSourceInfo = (sourceKeys: string[]) => {
    return (
      sourceKeys
        .map((key) => item.overview.trendOrigin.sources[key])
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        .filter((source) => source !== undefined)
        .map((source) => ({
          title: getSourceLabel(source),
          url: source.url || undefined,
        }))
        .filter((source) => Boolean(source.title))
    );
  };

  return (
    <div data-testid="social-brief-why-it-matters-section">
      <SectionTitle
        title={t('socialBriefWidget.whyItMattersSection.whyThisMattersForYour')}
        icon={<ChartColumnIcon className="size-5" />}
        tooltip={t('socialBriefWidget.whyItMattersSection.clarifyTheRelevanceBehindThis')}
      />
      <DetailSection>
        {item.overview.whyMattersToBrand.insightReasonings.map((reasoning, index) => (
          <DetailSectionItem
            key={index}
            title={reasoning.title}
            description={reasoning.description}
            icon={<CircleCheckIcon />}
            sources={mapSourceKeysToSourceInfo(reasoning.sourceKeys)}
          />
        ))}
      </DetailSection>
    </div>
  );
}
